export enum ProjectAnalysisTab {
  Models = "Models",
  Scenarios = "Scenarios",
  Assign = "Assign",
  Results = "Results",
  Additions = "Additions",
}
export type ProjectAnalysisTabType = `${ProjectAnalysisTab}`;

export const ProjectAnalysisTabs: Record<ProjectAnalysisTabType, number> = {
  Models: 0,
  Scenarios: 1,
  Assign: 2,
  Results: 3,
  Additions: 4,
};
